import dayjs from "dayjs"
import { t } from "i18next"
import { convertToReadableString, localisedValue } from "utils"
import { dateTimeFunction } from "utils/date"

const amountTypes = () => ({
  percentage: t("Percentage"),
  amount: t("Amount"),
})

export const leadsTransformer = res => {
  if (res?.length > 0) {
    return res[0]
  }
  return res
}
export const projectsTransformer = res => {
  let disputedItems = []
  let { projectUnits, leads, clients } = res?.claims[0] || {}
  projectUnits?.length > 0 &&
    projectUnits.map(item => {
      disputedItems.push({
        ...item,
        itemTitle: t("Project Unit"),
        key: `${item?.unitId}-project-unit`,
        type: "project-unit",
      })
    })
  leads?.length > 0 &&
    leads.map(item => {
      disputedItems.push({
        ...item,
        itemTitle: t("Lead Id"),
        key: `${item?.id}-lead-id`,
        type: "lead-id",
      })
    })
  clients?.length > 0 &&
    clients.map(item => {
      disputedItems.push({
        ...item,
        itemTitle: t("Client ID"),
        key: `${item?.id}-client-id`,
        type: "client-id",
      })
    })
  return {
    ...res,
    claims: [
      { ...res?.claims[0], disputeOnItems: disputedItems, anonymous: res?.reportedAnonymously },
      ...res.claims.slice(1),
    ],
  }
}

export const unitTypesWithSubTypesTransformer = res => {
  const transformedArray = res.map(item => {
    const { children } = item
    return {
      title: item?.name,
      value: item?.id.toString(),
      key: item?.id.toString(),
      ...(children?.length && { children: unitTypesWithSubTypesTransformer(children) }),
    }
  })
  return transformedArray
}

export const unitSubTypesBasedTranformer = res => {
  return res?.map(item => {
    return {
      ...item,
      label: item?.name,
      options: item?.children
        ? item?.children?.map(item => ({ label: item?.name, value: item?.id?.toString(), key: item?.id?.toString() }))
        : [],
    }
  })
}

export const projectDetailTransformer = res => {
  let projectDetail = res

  for (const [key, value] of Object.entries(res)) {
    if (Array.isArray(value) && !value.length) {
      projectDetail[key] = null
    } else if (typeof value === "object" && !!value) {
      !Object.keys(value).length && (projectDetail[key] = null)
    }
  }

  let policyFormData = projectDetail?.ProjectPolicyConfigurations?.reduce(
    (initialObj, data) => ({
      ...initialObj,
      [data?.policyId]: {
        policies: data?.policyConfigs,
        isTimeBoundPolicy: data?.isTimeBoundPolicy,
        policyEndDate: dayjs(data?.policyEndDate).isValid()
          ? dateTimeFunction({ date: data?.policyEndDate, Default: true })
          : null,
        recipients: data?.recipients?.join(", ") || "",
      },
    }),
    {}
  )

  let basicInfoKeys = [
    "name",
    "description",
    "url",
    "Address.Country",
    "projectState",
    "projectCity",
    "Address.localityId",
    "externalId",
  ]
  let mediaKeys = ["Logo"]

  let developerKeys = [
    "ProjectDeveloper.name",
    "ProjectDeveloper.Logo",
    "ProjectDeveloper.brief",
    "ProjectDeveloper.Address.addressLine1",
    "ProjectDeveloper.Address.countryId",
    "ProjectDeveloper.projectDeveloperState",
    "ProjectDeveloper.Address.localityId",
    "ProjectDeveloper.projectDeveloperCity",
  ]

  let bookingFormKeys = ["Possessions"]

  let invoicingTaxationKeys = [
    "ProjectDeveloper.invoicePaymentModes",
    "minToken",
    "partialDp",
    "ProjectFinancial.completeDownPayment",
    "paymentMode",
    "paymentProof",
    "Instalments",
    "issuePaymentReceipt",
  ]

  const isComplete = mandatoryKeys => {
    let complete = mandatoryKeys.every(key => {
      let keys = key.split(".")
      let value = projectDetail
      for (let key of keys) {
        value = value?.[key]
      }
      return Array.isArray(value) ? !!value.length : !!value
    })
    return complete
  }

  let stages = {
    project: { complete: isComplete(basicInfoKeys) },
    media: { complete: isComplete(mediaKeys) },
    developer: { complete: isComplete(developerKeys) },
    discount: { complete: true },
    bookingInfo: { complete: isComplete(bookingFormKeys) },
    bookingFormConfiguration: { complete: true },
    contractExpiry: { complete: !!(projectDetail?.hasCustomRules || projectDetail?.hasCustomRulesMortgage) },
    invoicing: { complete: isComplete(invoicingTaxationKeys) },
    pricing: { complete: true },
    setting: { complete: true },
  }
  projectDetail["ProjectPromoTags"] = projectDetail?.ProjectPromoTags?.map(tag => tag?.title)
  projectDetail["vasServices"] = projectDetail?.ProjectFinancial?.vasFees?.map(item => ({
    serviceType: { key: item?.key, value: item?.key, name: localisedValue({ object: item, key: "name" }) },
    amountType: { value: item?.amountBy, name: amountTypes()?.[item?.amountBy] },
    amount: item?.amountValue,
    type: {
      value: !!item?.isMandatory ? "mandatory" : "optional",
      name: !!item?.isMandatory ? t("Mandatory") : t("Optional"),
    },
    tax: item?.taxPercentage,
  }))

  const instalmentsMap = res?.Instalments?.reduce((acc, item) => {
    if (item?.type) acc[item.type] = item
    return acc
  }, {})

  return { ...projectDetail, policyFormData, ...stages, instalmentsMap }
}

export const inventoryUnitTypesTransformer = res => {
  return res.map(item => ({
    ...item,
    label: item?.name,
    options: item?.children?.map(item => ({ ...item, label: item?.name, value: item?.id?.toString(), id: item?.id })),
  }))
}
